export default defineAppConfig({
  nuxtIcon: {},
})
